<template>
  <div class="course-create-wrap">
    <a-form :form="form">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">课时信息</div>
        <div class="info-content" style="padding-top:25px;padding-bottom:30px;">
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="课时名称"
              >
                <a-input
                  placeholder="请输入课时名称"
                  v-decorator="[
                    'chName',
                    {rules: [{ required: true, message: '请输入课时名称' }]},
                  ]"
                />
                <!-- <span class="leave-num-count"></span> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="课时简介   "
              >
                <a-textarea
                  style="height:80px;resize: none;"
                  placeholder="请输入课时简介"
                  v-decorator="[
                    'chProfile',
                    {rules: [{ required: true, message: '请输入课时简介' }]},
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="课时封面   "
              >
                <div class>
                  <div class="clearfix">
                    <a-upload
                      v-decorator="[
                    'chCover',
                    {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: true, message: '请上传封面图片' }]},
                  ]"
                      listType="picture-card"
                      class="face-picture"
                      :showUploadList="false"
                      :action="uploadAction"
                      :headers="headers"
                      :beforeUpload="imgBeforeUpload"
                      @change="courseCoverChange"
                    >
                      <img
                        v-if="chCover.obsObjectUrl"
                        :src="chCover.obsObjectUrl"
                        style="width:100%;"
                      />
                      <div v-else>
                        <a-icon :type="faceloading ? 'loading' : 'plus'" />
                        <div class="ant-upload-text"></div>
                      </div>
                    </a-upload>

                  </div>
                </div>
                <div class="img-tip">请上传240*200像素或同比例的图片，小于5M!</div>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="课时顺序   ">
                <a-input placeholder="请输入课时顺序"  
                    v-decorator="[
                    'chOrder',
                    {rules: [{ required: true, message: '请输入课时顺序' }]}
                  ]"/>
                <!-- <span class="leave-num-count"></span> -->
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 8 }"
                label="上传音频   "
              >
                <div class>
                  <div class="clearfix">
                    <a-upload
                      v-decorator="[
                    'audio',
                    {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: true, message: '请上传音频' }]},
                  ]"
                      listType="picture-card"
                      class="face-picture"
                      :showUploadList="false"
                      :action="uploadAction"
                      :headers="headers"
                      :beforeUpload="videoBeforeUpload"
                      @change="videoChange"
                    >
                      <span v-if="audio.obsObjectUrl&&!videoloading">已上传</span>
                      <div v-else>
                        <a-icon :type="videoloading ? 'loading' : 'plus'" />
                        <div class="ant-upload-text">正在上传...</div>
                      </div>
                    </a-upload>
                    <div style="position: absolute;left:157px;top: 0px;">
                      <vue-qr :text="downloadData.url" :margin="0" colorDark="#FD8F16" colorLight="#fff" :logoSrc="downloadData.icon + '?cache'" :logoScale="0.2" :size="80"></vue-qr>
                    </div>
                  </div>
                </div>
              </a-form-item>

            </a-col>
            
          </a-row>

        </div>
      </a-card>
      <a-card
        :bordered="false"
        style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);"
      >
        <div class="a-row">
          <a-button
            style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;"
            type="primary"
            @click="videoCreateOk()"
          >保存</a-button>
        </div>
      </a-card>
    </a-form>
  </div>
</template>

<script>

  import Vue from 'vue'
  import { ACCESS_TOKEN ,TENANT_ID } from "@/store/mutation-types"

  import {addCourseHour,queryChDetail,updateCourseHour} from '@/api/api'

  import pick from 'lodash.pick'

  import _ from 'lodash'
  import moment from 'moment'

  import vueQr from 'vue-qr'



  // import moment from 'moment'
  // import pick from 'lodash.pick'
  // import { FormTypes } from '@/utils/JEditableTableUtil'
  // import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  function getBase64 (img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }
  export default {
    name: 'CourseCreate',
    components: {vueQr},
    mixins: [],
    data() {
      return {
        downloadButton:false,
        downloadData: {
          url: '',
          icon: window._CONFIG['domianURLHttp']+'/smlogo.jpg'
        },
        // config: {
        //     value: 'https://baidu.com',
        //     imagePath: 'http://www.elinkx.com.cn:3000/img/logo.bb4c241e.png',
        //     filter: 'color'
        // },
        courseId:"",//编辑的时候的课程id
        chName:"", //课程名称
        chProfile:"",//课程简介
        chOrder:"",
        chCover:{
          obsObjectUrl:""
        },//课程封面
        courseTeachers:[
          {
              // id:"",
              idSrc:"",
              teacherDesc:"",
              teacherName:"",
              headFile:""
          }
        ],//课程讲师
        faceloading:false,
        videoloading:false,

        audio:{
          obsObjectUrl:""
        },

        form: this.$form.createForm(this),
        loading: false,
        imageUrl: '',
        previewVisible: false,
        previewImage: '',
        fileList: [
        //   {
        //   uid: '-1',
        //   name: 'xxx.png',
        //   status: 'done',
        //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        // }
        ],
        url:{
          fileUpload: window._CONFIG['domianURL']+"/sys/common/upload",
        }
      }
    },
    
    methods: {
      normFile(e) {
        console.log('Upload event:', e);
        if (Array.isArray(e)) {
          return e;
        }
        return e && e.file&&e.file.response&&e.file.response.result;
      },
  
      videoChange (info,j,k) {
        if (info.file.status === 'uploading') {
          this.videoloading = true
          return
        }

        if (info.file.status === 'done') {
          this.audio = info.file.response.result;
          this.videoloading = false;
          this.downloadData.url = window._CONFIG['domianURLHttp']+"/mediaPlay?type=0&id="+this.audio.id

        }

      },

      courseCoverChange(info,i,j){
        if (info.file.status === 'uploading') {
          this.faceloading = true
          return
        }
        if (info.file.status === 'done') {

          this.chCover = info.file.response.result;
       
        }
      },

      // 图片上传前校验
      imgBeforeUpload (file) {
        const isJPG = /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(file.name);

        if(!isJPG){
          this.$message.error('只能上传图片!')
        }
       
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isLt5M) {
          this.$message.error('图片大小要小于5MB!')
        }
        return isJPG && isLt5M
      },

      // 音频上传前校验
      videoBeforeUpload (file) {
        const isJPG = /\.(mp3|acc)$/.test(file.name);

        if(!isJPG){
          this.$message.error('只能上传mp4视频!')
        }
       
        const isLt10M = file.size / 1024 / 1024 < 500
        if (!isLt10M) {
          this.$message.error('图片大小要小于500MB!')
        }
        return isJPG && isLt10M
      },


      // 保存
      videoCreateOk(){
        this.form.validateFields((err, values) => {
          if (!err) {

            let courseId = this.courseId;
            let chapterId = this.chapterId;
            let id = this.id;

            let valuesParam = {};
            valuesParam = {...values,courseId,chapterId,chType:4};

            let opFun = "";
            if(_.isEmpty(this.id)){
              opFun = addCourseHour(valuesParam);
            }else{
              valuesParam = {...valuesParam,id}
              opFun = updateCourseHour(valuesParam)  
            }

            opFun.then((res)=>{
              if(res.success==true){
                this.$message.success(res.message,()=>{
                  this.$router.push({ path:'/myCourse/courseDetailEdite?courseId='+this.courseId});
                });
                
              }else{
                this.$message.warning(res.message);
              }

            }).finally(() => {
              // that.confirmLoading = false;
              // that.checkedDepartNames = [];
              // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

              // that.close();
            })


          }
        })
      },
      
    },
    
    created () {
      const token = Vue.ls.get(ACCESS_TOKEN);
      let tenantid = Vue.ls.get(TENANT_ID)

      this.headers = {"X-Access-Token":token,"tenant_id":tenantid}

      this.courseId = this.$route.query.courseId;
      this.chapterId = this.$route.query.chapterId;
      this.id = this.$route.query.id;
    
      if(!_.isEmpty(this.id)){
        queryChDetail({id:this.id}).then((res)=>{
          if(res.code==0){
            console.log(res)
            let resultData = res.result;
            resultData['courseStartDate'] = moment(resultData['courseStartDate'], "YYYY-MM-DD")

            this.$nextTick(() => {
              this.form.setFieldsValue(pick(resultData,'chName','chProfile','chOrder',
              'chCover','audio'))
            });

            this.chCover = resultData.chCover?resultData.chCover:{obsObjectUrl:""};
            this.audio = resultData.audio?resultData.audio:{obsObjectUrl:""};

            this.downloadData.url = window._CONFIG['domianURLHttp']+"/mediaPlay?type=0&id="+this.audio.id;
            
           

          }else{
            this.$message.warning(res.message);
          }

        }).finally(() => {
          // that.confirmLoading = false;
          // that.checkedDepartNames = [];
          // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

          // that.close();
        })
      }
      
    },
    computed:{
      uploadAction:function () {
        return this.url.fileUpload;
      }
    },
  }
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
.course-create-wrap {
  .info-title {
    border-bottom: 1px solid #e7ecef;
    line-height: 50px;
    height: 50px;
    padding-left: 25px;
  }

  .info-content {
    .img-tip {
      color: #999999;
      font-size: 12px;
    }
  }
}
</style>